import request from '../utils/request';

export const getAllDept = ({ token, lang }) => {
  let url = `/iwork/dept/findDeptTrees?deptFrom=-1&lang=${lang}&level=-1`;
  return request(url, { headers: { token: token } });
};
export const saveDept = ({ parId, level, sonName, token, lang }) => {
  let url = `/iwork/dept/saveDept?parId=${parId}&level=${level}&sonName=${sonName}&lang=${lang}`;
  return request(url, { headers: { token: token } });
};
export const updateDept = ({ deptId, name, token, lang }) => {
  let url = `/iwork/dept/updateDept?deptId=${deptId}&name=${name}&lang=${lang}`;
  return request(url, { headers: { token: token } });
};
export const deleteDept = ({ deptId, token, lang }) => {
  let url = `/iwork/dept/deleteDept?deptId=${deptId}&lang=${lang}`;
  return request(url, { headers: { token: token } });
};



// WEBPACK FOOTER //
// ./src/services/deptUserManage.js